import { Redirect, Route } from 'react-router-dom';

import api from 'api/client';
import React, { useEffect } from 'react';
import { userStore } from 'store/UserStore';
import { useLocation } from 'react-router-dom';
import { makeQuery } from '../utils';
const PrivateRoute = ({ component: Component, ...rest }) => {
  const token = api.getToken();
  const [user, customerId] = userStore((state: any) => [
    state.user,
    state.customerId,
  ]);
  const location = useLocation();
  let ID = new URLSearchParams(location.search).get('customerId');
  var query = {
    ...(ID ? { customerId: ID } : {}),
    ...(ID ? { returnUrl: '/passbook' } : {}),
  };


  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={(props) =>
        token ? (
          // <Main>
          <Component {...props} />
        ) : (
          // </Main>
          <Redirect to={'/signin?' + makeQuery(query)} />
        )
      }
    />
  );
};

export default PrivateRoute;
